module.exports = __webpack_public_path__ + "img/APS.69e96a7c.png";